//React & Redux imports
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
//Helper
import dayjs from "dayjs";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { FieldFailureReportsGetAPI, getFieldFailureReportsUpdateAPICall } from "../services/apiCalls";
import { FieldFailureReportsKeys } from "../services/entity";
import { CheckListDataGrid } from "../CheckList/ChecklistDataGrid";
//PopUp
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import WarrantyPartModal from "../components/warrantyPartModal";
//Icons & Style
import { setReducerState } from "../../../redux/crudSlice";
import ConfirmationPopUp from "../components/confirmationPopUp";
import { PrintIconSVG } from "../../spareParts/purchaseRequistion/assets/customIcons";
import { Download, MoreVert } from "@mui/icons-material";
import { ReactComponent as LinkSvg } from "../../../assets/images/linkIcon.svg";
import { InfoIcon, TrashIcon } from "../../../assets/customIcons";
import { ReactComponent as LeftArrow } from "../../../assets/images/arrow-left.svg";
import { secondary } from "../../../theme/colors";
import { ShareIcon } from "../../../assets/images";
import { useMediaQuery } from "@mui/material";
import { PhysicalFormData, PhysicalFormDataMobileView } from "../components/fieldFailureReportCreateForm/PhysicalPhenamena";
import { AdditionalTab } from "../components/fieldFailureReportCreateForm/AdditionalTab";
import { getProductDetailsCard } from "../components/fieldFailureReportCreateForm/ProductDetailsCard";
import { CustomerComplaintCard } from "../components/fieldFailureReportCreateForm/CustomerComplaintCard";
import ActionMenuList from "../../../builderPackage/components/actionsMenuList";
import { basicDetailsAndVehicleDetails } from "../components/fieldFailureReportCreateForm/BasicDetailsAndVehicleDetails";
export var EditFieldFailureReport = function (props) {
    var _crud$FieldFailureRep, _crud$FieldFailureRep2, _crud$FieldFailureRep3, _crud$FieldFailureRep4, _crud$FieldFailureRep5, _crud$FieldFailureRep6, _crud$FieldFailureRep7, _crud$FieldFailureRep8, _crud$FieldFailureRep9, _crud$FieldFailureRep10, _crud$FieldFailureRep11, _crud$FieldFailureRep12, _crud$FieldFailureRep13, _crud$FieldFailureRep14, _crud$FieldFailureRep15, _crud$FieldFailureRep16, _crud$FieldFailureRep17, _crud$FieldFailureRep18, _crud$FieldFailureRep19, _crud$FieldFailureRep20;
    var value = props.value, name = props.name;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    /**
     * Fetch data from redux
     */
    var crud = useAppSelector(function (state) { return state.crud; });
    /**
     * Exporting props
     */
    var exportProps = {
        warrantyPartModal: (_crud$FieldFailureRep = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep === void 0 || (_crud$FieldFailureRep = _crud$FieldFailureRep.data) === null || _crud$FieldFailureRep === void 0 ? void 0 : _crud$FieldFailureRep.WarrantyPartData
    };
    /**
     * Update redux store
     */
    var dispatch = useAppDispatch();
    /**
     * ID to check is User Manual or Auto
     */
    var id = useParams().id;
    /**
     * For Navigation
     */
    var navigate = useNavigate();
    /**
     * trigger warranty modal
     */
    var showWarrantyDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!lgMode) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(showSurface({
                            type: "Dialog",
                            Component: WarrantyPartModal,
                            containerProps: {
                                fullWidth: true
                            },
                            componentProps: {
                                data: exportProps.warrantyPartModal,
                                id: id
                            }
                        }))];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, dispatch(showSurface({
                        type: "Drawer",
                        Component: WarrantyPartModal,
                        // containerProps: { fullWidth: true },
                        componentProps: {
                            data: exportProps.warrantyPartModal,
                            id: id
                        },
                        containerProps: {
                            anchor: 'bottom',
                            PaperProps: {
                                sx: {
                                    width: {
                                        xs: '100%',
                                        sm: '70%',
                                        md: '40%'
                                    },
                                    height: {
                                        xs: '80%',
                                        sm: '100%'
                                    },
                                    borderTopLeftRadius: 16,
                                    borderTopRightRadius: 16
                                }
                            }
                        }
                    }))];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var BasicDetailsAndVehicleDetails = basicDetailsAndVehicleDetails((_crud$FieldFailureRep2 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep2 === void 0 || (_crud$FieldFailureRep2 = _crud$FieldFailureRep2.data) === null || _crud$FieldFailureRep2 === void 0 ? void 0 : _crud$FieldFailureRep2.IsManual, showWarrantyDetails);
    /**
     * set reducer initial set
     */
    var handBackClick = function () {
        navigate("/fieldFailureReports");
        dispatch(setReducerState({
            key: FieldFailureReportsKeys.get,
            value: null
        }));
    };
    var ProductDetailsCard = getProductDetailsCard(lgMode);
    //General TAB
    var generalTab = [{
            type: FormItemTypes.ContainerItem,
            name: "",
            columnSize: 12,
            sx: {
                border: "1px",
                borderRadius: "12px",
                borderColor: "secondary.200"
            },
            elements: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], BasicDetailsAndVehicleDetails, true), ProductDetailsCard, true), [
                // --------------------------------------------------------------------------
                // Repair Details View Only - For Auto
                // -----------------------------------------------------------------------------
                ((_crud$FieldFailureRep3 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep3 === void 0 || (_crud$FieldFailureRep3 = _crud$FieldFailureRep3.data) === null || _crud$FieldFailureRep3 === void 0 ? void 0 : _crud$FieldFailureRep3.IsManual) == 0 ? {
                    type: FormItemTypes.CardComponent,
                    name: "RepairDetails",
                    label: "Repair Details",
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: "",
                            label: "",
                            columnSize: 12,
                            sx: {
                                backgroundColor: "secondary.50"
                            },
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: "Branch",
                                    label: "Branch",
                                    value: ((_crud$FieldFailureRep4 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep4 === void 0 || (_crud$FieldFailureRep4 = _crud$FieldFailureRep4.data) === null || _crud$FieldFailureRep4 === void 0 ? void 0 : _crud$FieldFailureRep4.BranchName) == null ? "-" : "".concat((_crud$FieldFailureRep5 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep5 === void 0 || (_crud$FieldFailureRep5 = _crud$FieldFailureRep5.data) === null || _crud$FieldFailureRep5 === void 0 ? void 0 : _crud$FieldFailureRep5.BranchName, " - ").concat((_crud$FieldFailureRep6 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep6 === void 0 || (_crud$FieldFailureRep6 = _crud$FieldFailureRep6.data) === null || _crud$FieldFailureRep6 === void 0 ? void 0 : _crud$FieldFailureRep6.BranchCode)
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "JobCardNumber",
                                    value: name == null ? "-" : name,
                                    label: "Job card number"
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "Part",
                                    label: "Part",
                                    value: ((_crud$FieldFailureRep7 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep7 === void 0 || (_crud$FieldFailureRep7 = _crud$FieldFailureRep7.data) === null || _crud$FieldFailureRep7 === void 0 ? void 0 : _crud$FieldFailureRep7.PartName) == null ? "-" : "".concat((_crud$FieldFailureRep8 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep8 === void 0 || (_crud$FieldFailureRep8 = _crud$FieldFailureRep8.data) === null || _crud$FieldFailureRep8 === void 0 ? void 0 : _crud$FieldFailureRep8.PartName, " - ").concat((_crud$FieldFailureRep9 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep9 === void 0 || (_crud$FieldFailureRep9 = _crud$FieldFailureRep9.data) === null || _crud$FieldFailureRep9 === void 0 ? void 0 : _crud$FieldFailureRep9.PartCode)
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "KMReading",
                                    value: name == null ? "-" : name,
                                    label: "KM reading"
                                }, {
                                    type: FormItemTypes.Typography,
                                    label: "Repair Type",
                                    name: "RepairTypeData",
                                    value: ((_crud$FieldFailureRep10 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep10 === void 0 || (_crud$FieldFailureRep10 = _crud$FieldFailureRep10.data) === null || _crud$FieldFailureRep10 === void 0 ? void 0 : _crud$FieldFailureRep10.RepairType) == null ? "-" : "".concat((_crud$FieldFailureRep11 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep11 === void 0 || (_crud$FieldFailureRep11 = _crud$FieldFailureRep11.data) === null || _crud$FieldFailureRep11 === void 0 ? void 0 : _crud$FieldFailureRep11.RepairType, " - ").concat((_crud$FieldFailureRep12 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep12 === void 0 || (_crud$FieldFailureRep12 = _crud$FieldFailureRep12.data) === null || _crud$FieldFailureRep12 === void 0 ? void 0 : _crud$FieldFailureRep12.RepairTypeCode)
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "DateOfFailure",
                                    label: "Date of failure",
                                    value: name == null ? "-" : name,
                                    valueGetter: function (formValues, field) {
                                        var _field$name, _field$name2;
                                        return formValues !== null && formValues !== void 0 && formValues[(_field$name = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name !== void 0 ? _field$name : ""] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name2 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name2 !== void 0 ? _field$name2 : ""]).format("DD MMM, YYYY") : "-";
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "RepairDate",
                                    label: "Repair date",
                                    value: name == null ? "-" : name,
                                    valueGetter: function (formValues, field) {
                                        var _field$name3, _field$name4;
                                        return formValues !== null && formValues !== void 0 && formValues[(_field$name3 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name3 !== void 0 ? _field$name3 : ""] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name4 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name4 !== void 0 ? _field$name4 : ""]).format("DD MMM, YYYY") : "-";
                                    }
                                }, {
                                    type: FormItemTypes.Custom,
                                    name: ""
                                }]
                        }, {
                            type: FormItemTypes.CardComponent,
                            sx: {
                                border: "none"
                            },
                            name: "",
                            label: "",
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.TextInput,
                                    name: "VendorName",
                                    label: "Vendor name",
                                    value: null,
                                    placeholder: "E.g Naveen Enterprises",
                                    validator: function (value) {
                                        var conditionRegex = /^[A-Za-z0-99\s]+$/; // Only letters and spaces
                                        var leadingSpacesRegex = /^\S.*$/;
                                        if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                            return "Leading spaces are not allowed.";
                                        }
                                        if (!conditionRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                            return "Special characters are not allowed";
                                        }
                                        return undefined;
                                    }
                                }, {
                                    type: FormItemTypes.DatePicker,
                                    name: "RepairDate",
                                    label: "Repair date",
                                    value: null,
                                    placeholder: "E.g. 6 Jan, 2025",
                                    disableFuture: true,
                                    setFieldProps: function (formValues) {
                                        return {
                                            minDate: dayjs.utc(formValues.DateOfFailure)
                                        };
                                    }
                                }, {
                                    type: FormItemTypes.TextInput,
                                    name: "Reporter",
                                    label: "Reported by",
                                    value: null,
                                    placeholder: "E.g. Ganesh Tavde",
                                    required: true,
                                    validator: function (value, state) {
                                        var nameRegex = /^[A-Za-z\s]+$/;
                                        var leadingSpacesRegex = /^\S.*$/;
                                        if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                            return "Leading spaces are not allowed.";
                                        }
                                        if (!nameRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                            return "Only alphabetic characters are allowed";
                                        }
                                        if ((value === null || value === void 0 ? void 0 : value.length) < 5) {
                                            return 'Reported by must be at least 5 characters';
                                        }
                                        if ((value === null || value === void 0 ? void 0 : value.length) > 20) {
                                            return 'Reported by must be no longer than 20 characters';
                                        }
                                        return undefined;
                                    }
                                }, {
                                    type: FormItemTypes.NumberInput,
                                    name: "ReporterContact",
                                    label: "Reporter mobile number",
                                    value: null,
                                    placeholder: "E.g. 9947829947",
                                    required: true,
                                    validator: function (value) {
                                        var conditionRegex = /^[0-99\s]+$/;
                                        var trimmedValue = value === null || value === void 0 ? void 0 : value.trim();
                                        if (!conditionRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                            return "Only numbers are allowed";
                                        }
                                        if (!trimmedValue || (trimmedValue === null || trimmedValue === void 0 ? void 0 : trimmedValue.length) !== 10) {
                                            return "Mobile number must be 10 digits";
                                        }
                                        if (/^(\d)\1{9}$/.test(trimmedValue)) {
                                            return "Invalid mobile number";
                                        }
                                        return undefined;
                                    }
                                }, {
                                    type: FormItemTypes.TextInput,
                                    name: "PartsReplaced",
                                    value: null,
                                    label: "Parts replaced",
                                    placeholder: "E.g. Break Pads, etc.",
                                    required: true
                                }, {
                                    type: FormItemTypes.TextInput,
                                    name: "VehicleStatusAfterRepair",
                                    value: null,
                                    label: "Vehicle status after repair",
                                    placeholder: "E.g. Repaired",
                                    required: true
                                }]
                        }]
                } : null,
                // --------------------------------------------------------------------------
                // Repair Details View Only Manual
                // -----------------------------------------------------------------------------
                ((_crud$FieldFailureRep13 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep13 === void 0 || (_crud$FieldFailureRep13 = _crud$FieldFailureRep13.data) === null || _crud$FieldFailureRep13 === void 0 ? void 0 : _crud$FieldFailureRep13.IsManual) == 1 ? {
                    type: FormItemTypes.CardComponent,
                    name: "RepairDetails",
                    label: "Repair Details",
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.TextInput,
                            name: "Branch",
                            label: "Branch",
                            value: ((_crud$FieldFailureRep14 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep14 === void 0 || (_crud$FieldFailureRep14 = _crud$FieldFailureRep14.data) === null || _crud$FieldFailureRep14 === void 0 ? void 0 : _crud$FieldFailureRep14.BranchName) == null ? "-" : "".concat((_crud$FieldFailureRep15 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep15 === void 0 || (_crud$FieldFailureRep15 = _crud$FieldFailureRep15.data) === null || _crud$FieldFailureRep15 === void 0 ? void 0 : _crud$FieldFailureRep15.BranchName, " - ").concat((_crud$FieldFailureRep16 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep16 === void 0 || (_crud$FieldFailureRep16 = _crud$FieldFailureRep16.data) === null || _crud$FieldFailureRep16 === void 0 ? void 0 : _crud$FieldFailureRep16.BranchCode),
                            required: false,
                            disabled: true
                        }, {
                            type: FormItemTypes.TextInput,
                            name: "JobCardNumber",
                            label: "Job card number",
                            value: null,
                            disabled: true,
                            placeholder: "E.g JC-9939002",
                            validator: function (value, state) {
                                var jobCardRegex = /^[A-Za-z0-9-]+$/;
                                if (!jobCardRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                    return "Only alphanumeric characters and hyphens (-) are allowed";
                                }
                                if ((value === null || value === void 0 ? void 0 : value.length) < 10) {
                                    return "Job card number must be at least 10 characters";
                                }
                                if ((value === null || value === void 0 ? void 0 : value.length) > 20) {
                                    return "Job card number must be no longer than 20 characters";
                                }
                                return undefined;
                            }
                        }, {
                            type: FormItemTypes.TextInput,
                            name: "Part",
                            label: "Part",
                            value: "".concat((_crud$FieldFailureRep17 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep17 === void 0 || (_crud$FieldFailureRep17 = _crud$FieldFailureRep17.data) === null || _crud$FieldFailureRep17 === void 0 ? void 0 : _crud$FieldFailureRep17.PartName, " - ").concat((_crud$FieldFailureRep18 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep18 === void 0 || (_crud$FieldFailureRep18 = _crud$FieldFailureRep18.data) === null || _crud$FieldFailureRep18 === void 0 ? void 0 : _crud$FieldFailureRep18.PartCode),
                            required: false,
                            disabled: true
                        }, {
                            type: FormItemTypes.TextInput,
                            name: "VendorName",
                            label: "Vendor name",
                            value: null,
                            placeholder: "E.g Naveen Enterprises",
                            validator: function (value) {
                                var conditionRegex = /^[A-Za-z0-99\s]+$/; // Only letters and spaces
                                var leadingSpacesRegex = /^\S.*$/;
                                if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                    return "Leading spaces are not allowed.";
                                }
                                if (!conditionRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                    return "Special characters are not allowed";
                                }
                                return undefined;
                            }
                        }, {
                            type: FormItemTypes.TextInput,
                            name: "RepairTypeData",
                            label: "Repair Type",
                            value: "".concat((_crud$FieldFailureRep19 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep19 === void 0 || (_crud$FieldFailureRep19 = _crud$FieldFailureRep19.data) === null || _crud$FieldFailureRep19 === void 0 ? void 0 : _crud$FieldFailureRep19.RepairType, " - ").concat((_crud$FieldFailureRep20 = crud[FieldFailureReportsKeys.get]) === null || _crud$FieldFailureRep20 === void 0 || (_crud$FieldFailureRep20 = _crud$FieldFailureRep20.data) === null || _crud$FieldFailureRep20 === void 0 ? void 0 : _crud$FieldFailureRep20.RepairTypeCode),
                            required: false,
                            disabled: true
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: "RepairDate",
                            label: "Repair date",
                            value: null,
                            placeholder: "E.g. 6 Jan, 2025",
                            disableFuture: true,
                            setFieldProps: function (formValues) {
                                return {
                                    minDate: dayjs.utc(formValues.DateOfFailure)
                                };
                            }
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: "DateOfFailure",
                            label: "Date of failure",
                            value: null,
                            disableFuture: true,
                            placeholder: "E.g. 6 Jan, 2025",
                            required: true
                        }, {
                            type: FormItemTypes.NumberInput,
                            name: "KMReading",
                            label: "KM reading",
                            value: null,
                            placeholder: "E.g. 1200",
                            validator: function (value, state) {
                                if ((value === null || value === void 0 ? void 0 : value.length) < 1) {
                                    return "KM reading must be at least 1 digit";
                                }
                                if ((value === null || value === void 0 ? void 0 : value.length) > 10) {
                                    return "KM reading must be no longer than 10 digits";
                                }
                                return undefined;
                            }
                        }, {
                            type: FormItemTypes.DatePicker,
                            name: "ReportDate",
                            label: "Report date",
                            value: null,
                            placeholder: "E.g. 6 Jan, 2025",
                            disableFuture: true
                        }, {
                            type: FormItemTypes.TextInput,
                            name: "Reporter",
                            label: "Reported by",
                            placeholder: "E.g. Ganesh Tavde",
                            required: true,
                            validator: function (value) {
                                var nameRegex = /^[A-Za-z\s]+$/;
                                var leadingSpacesRegex = /^\S.*$/;
                                if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                    return "Leading spaces are not allowed.";
                                }
                                if (!nameRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                    return 'Only alphabetic characters are allowed';
                                }
                                if ((value === null || value === void 0 ? void 0 : value.length) < 5) {
                                    return 'Reported by must be at least 5 characters';
                                }
                                if ((value === null || value === void 0 ? void 0 : value.length) > 20) {
                                    return 'Reported by must be no longer than 20 characters';
                                }
                                return undefined;
                            }
                        }, {
                            type: FormItemTypes.NumberInput,
                            name: "ReporterContact",
                            label: "Reporter mobile number",
                            placeholder: "E.g. 9947829947",
                            required: true,
                            validator: function (value) {
                                var conditionRegex = /^[0-99\s]+$/;
                                if (!conditionRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                    return "Only numbers are allowed";
                                }
                                if (!value || (value === null || value === void 0 ? void 0 : value.length) !== 10) {
                                    return "Mobile number must be 10 digits";
                                }
                                if (/^(\d)\1{9}$/.test(value)) {
                                    return "Invalid mobile number";
                                }
                                return undefined;
                            }
                        }, {
                            type: FormItemTypes.TextInput,
                            name: "PartsReplaced",
                            value: null,
                            label: "Parts replaced",
                            placeholder: "E.g. Break Pads, etc.",
                            required: true,
                            validator: function (value) {
                                var leadingSpacesRegex = /^\S.*$/;
                                if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                    return "Leading spaces are not allowed.";
                                }
                                return undefined;
                            }
                        }, {
                            type: FormItemTypes.TextInput,
                            name: "VehicleStatusAfterRepair",
                            value: null,
                            label: "Vehicle status after repair",
                            placeholder: "E.g. Repaired",
                            required: true,
                            validator: function (value) {
                                var leadingSpacesRegex = /^\S.*$/;
                                if (!leadingSpacesRegex.test(value) && (value === null || value === void 0 ? void 0 : value.length) > 0) {
                                    return "Leading spaces are not allowed.";
                                }
                                return undefined;
                            }
                        }]
                } : null], false), CustomerComplaintCard, true)
        }];
    //Page Header
    var formState = [
        //---------------------------------------------------------------------
        // Main Header
        //---------------------------------------------------------------------
        {
            type: FormItemTypes.ContainerItem,
            name: "PageHeader",
            columnSize: 12,
            justifyContent: 'space-between',
            spacing: 0,
            p: 1,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    xs: 12,
                    sm: 5,
                    md: true,
                    lg: true,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(LeftArrow, null),
                            sx: {
                                color: 'secondary.600'
                            },
                            columnSize: 0,
                            onClick: function () {
                                handBackClick();
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: "",
                            label: "",
                            children: "New field failure report",
                            columnSize: 0,
                            fontSize: "xxl",
                            fontWeight: "strong"
                        }, {
                            type: FormItemTypes.Chip,
                            name: "Open",
                            label: "Open",
                            value: null,
                            columnSize: true,
                            color: "primary",
                            sx: {
                                marginTop: '3px',
                                marginLeft: '5px'
                            }
                        }, !lgMode ? {
                            type: FormItemTypes.Button,
                            name: 'More',
                            children: /*#__PURE__*/ React.createElement(MoreVert, null),
                            size: 'small',
                            variant: 'text',
                            color: 'secondary',
                            sx: {
                                p: '7px'
                            },
                            columnSize: 0,
                            setFormState: function (state, e) { return __awaiter(void 0, void 0, void 0, function () {
                                var action;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Menu',
                                                containerProps: {
                                                    anchorEl: e.target.parentElement
                                                },
                                                Component: ActionMenuList,
                                                componentProps: {
                                                    items: [{
                                                            id: 'download',
                                                            children: "Download"
                                                        }, {
                                                            id: 'share',
                                                            children: "Share"
                                                        }, {
                                                            id: 'print',
                                                            children: "Print"
                                                        }, {
                                                            id: 'quick links',
                                                            children: 'Quick links'
                                                        }]
                                                }
                                            }))];
                                        case 1:
                                            action = _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        } : null]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    xs: 12,
                    sm: true,
                    md: true,
                    lg: true,
                    spacing: 0,
                    item: false,
                    gap: 1,
                    justifyContent: {
                        xs: "space-between",
                        sm: 'end'
                    },
                    alignContent: 'center',
                    elements: lgMode ? [{
                            type: FormItemTypes.Typography,
                            name: "DocumentName",
                            label: "DOC NO :",
                            value: '-',
                            containerProps: {
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'end'
                                },
                                display: "inline-flex",
                                alignItems: "baseline",
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true
                            },
                            xs: 12,
                            sm: true,
                            md: true,
                            lg: true
                        }, {
                            type: FormItemTypes.Typography,
                            name: "DocumentDate",
                            label: "DOC DATE:",
                            value: '-',
                            containerProps: {
                                display: "inline-flex",
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'end'
                                },
                                alignItems: "baseline",
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true
                            },
                            columnSize: 0,
                            valueGetter: function (formValues, field) {
                                var _field$name5;
                                var value = formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name5 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name5 !== void 0 ? _field$name5 : ""];
                                if (value) {
                                    return dayjs(value).format("DD MMM, YYYY");
                                }
                                return dayjs().format("DD MMM, YYYY");
                            }
                        }] : [{
                            type: FormItemTypes.Typography,
                            name: "DocumentName",
                            label: "DOC NO :",
                            value: '-',
                            containerProps: {
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'end'
                                },
                                display: "inline-flex",
                                alignItems: "baseline",
                                gap: 1,
                                mx: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                mx: 1,
                                noWrap: true
                            },
                            xs: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: "DocumentDate",
                            label: "DOC DATE:",
                            value: '-',
                            containerProps: {
                                display: "inline-flex",
                                mx: 1,
                                justifyContent: {
                                    xs: "space-between",
                                    sm: 'end'
                                },
                                alignItems: "baseline",
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                mx: 1,
                                noWrap: true
                            },
                            xs: 12,
                            valueGetter: function (formValues, field) {
                                var _field$name6;
                                var value = formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name6 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name6 !== void 0 ? _field$name6 : ""];
                                if (value) {
                                    return dayjs(value).format("DD MMM, YYYY");
                                }
                                return dayjs().format("DD MMM, YYYY");
                            }
                        }]
                }]
        },
        // View Header - Search Quick link & rest button
        lgMode ? {
            type: FormItemTypes.Box,
            name: "",
            height: "68px",
            padding: "16px 24px",
            gap: "12px",
            bgcolor: secondary[100],
            mt: 2,
            borderTop: "1px solid ",
            borderBottom: "1px solid ",
            borderColor: secondary[200],
            columnSize: 12,
            justifyContent: "space-between",
            display: "flex",
            elements: [{
                    type: FormItemTypes.Box,
                    name: "",
                    columnSize: 3
                }, {
                    type: FormItemTypes.Box,
                    name: "",
                    justifyContent: "end",
                    display: "flex",
                    columnSize: 9,
                    gap: "12px",
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            variant: "text",
                            children: "Quick links",
                            columnSize: 0,
                            sx: {
                                bgcolor: "transparent",
                                fontWeight: "medium"
                            },
                            startIcon: /*#__PURE__*/ React.createElement(LinkSvg, null)
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(Download, null),
                            columnSize: 0,
                            variant: "outlined",
                            disabled: true,
                            sx: {
                                padding: "8px"
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement("img", {
                                src: ShareIcon,
                                alt: "shareicon",
                                loading: "lazy"
                            }),
                            columnSize: 0,
                            variant: "outlined",
                            disabled: true,
                            sx: {
                                padding: "8px"
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(PrintIconSVG, null),
                            columnSize: 0,
                            variant: "outlined",
                            disabled: true,
                            sx: {
                                padding: "8px"
                            }
                        }, {
                            type: FormItemTypes.Box,
                            name: "",
                            columnSize: 0,
                            height: "100%",
                            width: "1px",
                            bgcolor: "rgba(0,0,0,0.1)",
                            mx: 1
                        }, {
                            type: FormItemTypes.Button,
                            name: "form-save",
                            children: "Save",
                            columnSize: 0,
                            variant: "outlined",
                            color: "secondary",
                            setFormState: function () {
                                return {
                                    IsSubmit: 0
                                };
                            },
                            onClick: function (event, formValues) {
                                return 'submit';
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "submit",
                            label: "",
                            value: "submit",
                            children: "Submit",
                            columnSize: 0,
                            variant: "contained",
                            color: "primary",
                            setFormState: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    return [2 /*return*/, {
                                            IsSubmit: 1
                                        }];
                                });
                            }); },
                            onClick: function () {
                                return __awaiter(this, void 0, void 0, function () {
                                    var result;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, dispatch(showSurface({
                                                    type: 'Dialog',
                                                    Component: ConfirmationPopUp,
                                                    containerProps: {
                                                        fullWidth: true,
                                                        PaperProps: {
                                                            sx: {
                                                                borderRadius: '12px',
                                                                width: {
                                                                    sm: '350px',
                                                                    md: '450px',
                                                                    lg: '450px'
                                                                }
                                                            }
                                                        }
                                                    },
                                                    //Passing dynamic props
                                                    componentProps: {
                                                        unsavedChangesMessage: 'Are sure you want to submit?',
                                                        changesLostMessage: 'Document cannot be edited after submission.',
                                                        confirmButtonLabel: 'Submit',
                                                        discardButtonLabel: 'Cancel',
                                                        icon: /*#__PURE__*/ React.createElement(InfoIcon, null),
                                                        bgColor: 'warning.100',
                                                        hoverbgColor: 'warning.100'
                                                        // onClose: (isConfirmed: boolean) => {
                                                        //   console.log(isConfirmed ? 'Confirmed' : 'Canceled');
                                                        // },
                                                    }
                                                }))];
                                            case 1:
                                                result = _a.sent();
                                                if (result.payload) {
                                                    return [2 /*return*/, 'submit'];
                                                }
                                                return [2 /*return*/];
                                        }
                                    });
                                });
                            }
                        }]
                }]
        } : null,
        // -------------------------------------------------------------------------
        // Tabs
        // ----------------------------------------------------------------------------
        {
            type: FormItemTypes.ContainerItem,
            name: "",
            columnSize: 12,
            spacing: 0,
            containerProps: {
                spacing: 0
            },
            elements: [{
                    type: FormItemTypes.Tabs,
                    name: "Tabs",
                    tabs: [{
                            id: "0",
                            label: "General",
                            elements: generalTab,
                            containerProps: {
                                px: 3
                            }
                        }, {
                            id: "1",
                            label: "Physical Phenomena",
                            containerProps: {
                                px: lgMode ? 3 : 0
                            },
                            elements: lgMode ? PhysicalFormData : PhysicalFormDataMobileView
                        }, {
                            id: "2",
                            label: "Additional info",
                            elements: AdditionalTab,
                            containerProps: {
                                px: 3
                            }
                        }, {
                            id: "3",
                            label: "Checklist",
                            containerProps: {
                                px: 3
                            },
                            elements: [{
                                    type: FormItemTypes.ContainerItem,
                                    name: "",
                                    columnSize: 12,
                                    spacing: 0,
                                    columnGap: 1.5,
                                    alignItems: "center",
                                    py: 2.5,
                                    px: 2,
                                    elements: [{
                                            type: FormItemTypes.Custom,
                                            name: "ChecklistFeedbackData",
                                            columnSize: 12,
                                            element: CheckListDataGrid
                                        }]
                                }]
                        }],
                    valueExpr: "id",
                    displayExpr: "label",
                    columnSize: 12,
                    variant: "scrollable",
                    sx: {
                        margin: "0px 24px"
                    }
                }]
        }, !lgMode ? {
            type: FormItemTypes.ContainerItem,
            name: 'Footer',
            columnSize: 12,
            justifyContent: 'end',
            sx: {
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                padding: 2,
                backgroundColor: 'background.paper',
                borderTop: '1px solid',
                borderColor: 'divider',
                zIndex: 1
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: 12,
                    item: false,
                    spacing: 1,
                    alignItems: "center",
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "Discard",
                            label: "",
                            value: "discard",
                            children: "Discard",
                            columnSize: true,
                            variant: "text",
                            color: "secondary",
                            setFormState: function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: 'Dialog',
                                                Component: ConfirmationPopUp,
                                                containerProps: {
                                                    maxWidth: 'xs'
                                                },
                                                //Passing dynamic props
                                                componentProps: {
                                                    unsavedChangesMessage: 'You have unsaved changes. Are you sure you want to proceed?',
                                                    changesLostMessage: 'Your changes will be lost if you proceed.',
                                                    confirmButtonLabel: 'Discard',
                                                    discardButtonLabel: 'Cancel',
                                                    icon: /*#__PURE__*/ React.createElement(TrashIcon, null),
                                                    bgColor: 'error.100',
                                                    hoverbgColor: 'error.100'
                                                    // onClose: (isConfirmed: boolean) => {
                                                    //   console.log(isConfirmed ? 'Confirmed' : 'Canceled');
                                                    // },
                                                }
                                            }))];
                                        case 1:
                                            result = _a.sent();
                                            //Clearing form state for discard functionality
                                            if (result.payload)
                                                return [2 /*return*/, {
                                                        BranchId: '',
                                                        RepairTypeId: '',
                                                        search: '',
                                                        VendorName: '',
                                                        PartCodeId: '',
                                                        JobCardNumber: '',
                                                        RepairDate: null,
                                                        DateOfFailure: null,
                                                        KMReading: '',
                                                        ReportDate: null,
                                                        Reporter: "",
                                                        ReporterContact: "",
                                                        PartsReplaced: "",
                                                        VehicleStatusAfterRepair: "",
                                                        PerformanceCodeId: "",
                                                        DefectCodeId: "",
                                                        CauseOfFailure: "",
                                                        TemperatureConditionId: "",
                                                        VehicleSpeed: "",
                                                        RoadCondition: "",
                                                        //Additional Info
                                                        CourierName: '',
                                                        DocketNumber: '',
                                                        DispatchDate: null,
                                                        //physical phenomena
                                                        ParamsBeforeRepairData: [],
                                                        ParamsAfterRepairData: [],
                                                        DefectivePartIdentification: '',
                                                        //Attachment
                                                        Attachments: '',
                                                        ChecksheetFilledAttachments: ''
                                                    }];
                                            return [2 /*return*/, false];
                                    }
                                });
                            }); }
                        },
                        //Update FFR API call
                        {
                            type: FormItemTypes.Button,
                            name: "form-save",
                            children: "Save",
                            columnSize: 0,
                            variant: "outlined",
                            color: "secondary",
                            sx: {
                                mr: 1
                            },
                            setFormState: function () {
                                return {
                                    IsSubmit: 0
                                };
                            },
                            onClick: function (e, formvalues) {
                                return "submit";
                            }
                        },
                        //Create FFR API call
                        {
                            type: FormItemTypes.Button,
                            name: "form-submit",
                            children: "Submit",
                            columnSize: 0,
                            variant: "contained",
                            color: "primary",
                            setFormState: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    return [2 /*return*/, {
                                            IsSubmit: 1
                                        }];
                                });
                            }); },
                            sx: {
                                mr: 1
                            },
                            onClick: function () {
                                return __awaiter(this, void 0, void 0, function () {
                                    var result;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, dispatch(showSurface({
                                                    type: 'Dialog',
                                                    Component: ConfirmationPopUp,
                                                    containerProps: {
                                                        fullWidth: true,
                                                        PaperProps: {
                                                            sx: {
                                                                borderRadius: '12px',
                                                                width: {
                                                                    sm: '350px',
                                                                    md: '450px',
                                                                    lg: '450px'
                                                                }
                                                            }
                                                        }
                                                    },
                                                    //Passing dynamic props
                                                    componentProps: {
                                                        unsavedChangesMessage: 'Are sure you want to submit?',
                                                        changesLostMessage: 'Document cannot be edited after submission.',
                                                        confirmButtonLabel: 'Submit',
                                                        discardButtonLabel: 'Cancel',
                                                        icon: /*#__PURE__*/ React.createElement(InfoIcon, null),
                                                        bgColor: 'warning.100',
                                                        hoverbgColor: 'warning.100'
                                                        // onClose: (isConfirmed: boolean) => {
                                                        //   console.log(isConfirmed ? 'Confirmed' : 'Canceled');
                                                        // },
                                                    }
                                                }))];
                                            case 1:
                                                result = _a.sent();
                                                if (result.payload) {
                                                    return [2 /*return*/, 'submit'];
                                                }
                                                return [2 /*return*/];
                                        }
                                    });
                                });
                            }
                        }]
                }]
        } : null
    ];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formState,
        getFormAPI: FieldFailureReportsGetAPI,
        getKey: FieldFailureReportsKeys.get,
        getRequest: {
            id: id
        },
        gridProps: {
            spacing: 0
        },
        mode: "edit",
        updateFormAPI: getFieldFailureReportsUpdateAPICall,
        updateKey: FieldFailureReportsKeys.update,
        updateRequest: {
            id: id
        }
    }));
};
